export class FormsTestingToolApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async createFormBundleTestingTool(body) {
    return this.#http.post('/api/form-bundle-testing-tool', body);
  }

  async createFormBundleTestingToolPdf(body) {
    return this.#http.post('/api/form-bundle-testing-tool/pdf', body, { responseType: 'blob' });
  }
}
